const SOURCE_COLORS = {
  website: '#5B8DEF',
  facebook: '#3B5998',
  facebook_messenger: '#0084FF',
  direct: '#7E57C2',
  direct_link_scheduler: '#7E57C2',
  ai: '#00A896',
  ai_receptionist: '#00A896',
  email: '#F9A825',
  google: '#43A047',
  other: '#B0BEC5',
  unknown: '#90A4AE',
};

const SOURCE_ROW_COLORS = [
  SOURCE_COLORS.website,
  SOURCE_COLORS.ai,
  SOURCE_COLORS.email,
  SOURCE_COLORS.direct,
  SOURCE_COLORS.other,
];

const getSourceColor = (source = {}) => source.color
  || SOURCE_COLORS[source.color_key]
  || SOURCE_COLORS[source.source_key]
  || SOURCE_COLORS[source.source_key?.split('_')[0]]
  || SOURCE_COLORS.unknown;

const buildLeadsWidgetChartData = ({ buckets = [], sources = [] } = {}) => {
  const labels = buckets.map((bucket) => bucket.label);
  const sourceKeys = sources.map((source) => source.source_key);

  return {
    labels,
    datasets: sourceKeys.map((sourceKey) => {
      const source = sources.find((item) => item.source_key === sourceKey) || {};

      return {
        label: source.label || source.fallback_label || sourceKey,
        source_key: sourceKey,
        data: buckets.map((bucket) => bucket.sources?.[sourceKey] || 0),
        backgroundColor: getSourceColor(source),
        stack: 'leads',
      };
    }),
  };
};

const hasLeadsChartData = ({ buckets = [] } = {}) => buckets.some((bucket) => (
  Object.values(bucket.sources || {}).some((value) => value > 0)
));

export {
  SOURCE_COLORS,
  SOURCE_ROW_COLORS,
  buildLeadsWidgetChartData,
  hasLeadsChartData,
};
